import { toggleBodyClass } from "../../helpers";

export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const TOGGLE_SELECTOR = "TOGGLE_SELECTOR";
export const SET_RETURN_FOCUS = "SET_RETURN_FOCUS";

function toggleModalContainer() {
  return {
    type: TOGGLE_MODAL,
  };
}

function toggleCountrySelector() {
  return {
    type: TOGGLE_SELECTOR,
  };
}

export function setReturnFocus(returnFocus) {
  return {
    type: SET_RETURN_FOCUS,
    returnFocus,
  };
}

export function toggleModal(isActive, returnEl) {
  return (dispatch, getState) => {
    const {
      Modal: { returnFocus },
    } = getState();
    dispatch(toggleModalContainer());
    toggleBodyClass(isActive);
    window.scrollTo("body", 0);

    return isActive
      ? dispatch(setReturnFocus(returnEl))
      : returnFocus && returnFocus.focus();
  };
}

export function toggleSelector(isActive, returnEl) {
  return (dispatch, getState) => {
    const {
      Modal: { returnFocus },
    } = getState();
    dispatch(toggleCountrySelector());
    toggleBodyClass();
    window.scrollTo("body", 0);

    return isActive
      ? dispatch(setReturnFocus(returnEl))
      : returnFocus && returnFocus.focus();
  };
}
